import React, { FunctionComponent, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "../../sideBar.module.scss";
import dashboard_logo from "@view/SideBar/bxs-dashboard.png";
import { setSideBarInfo } from "@store";

const SideBarItemDashboard: FunctionComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/site_overview") {
      dispatch(setSideBarInfo({ category: "dashboard" }));
    }
  }, [location.pathname]);

  const sidebarState = useSelector((state: any) => {
    return {
      category: state.sidebar.category,
    };
  });

  return (
    <div
      className={styles.category}
      style={
        sidebarState.category === "dashboard"
          ? { backgroundColor: "#eaeaea" }
          : undefined
      }
      onClick={() => {
        dispatch(setSideBarInfo({ category: "dashboard" }));
        navigate("/site_overview", {
          state: { headbarTitle: "Dashboard" },
        });
      }}
    >
      <div
        className={
          sidebarState.category === "dashboard"
            ? styles.categoryInner_selected
            : styles.categoryInnner
        }
      >
        <div className={styles.categoryImgContainer}>
          <img className={styles.categoryImg} alt={""} src={dashboard_logo} />
        </div>
        <div className={styles.categoryWord}>Dashboard</div>
      </div>
    </div>
  );
};

export default SideBarItemDashboard;
